import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function SolutionSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section className="w-full py-14 md:py-24 px-6 relative" style={{
    background: '#111827'
  }} data-id="element-301">
      <div className="max-w-3xl mx-auto text-center" data-id="element-302">
        <div ref={ref} className={`reveal ${isVisible ? 'visible' : ''}`} data-id="element-303">
          <div className="amber-divider mb-8 md:mb-12" data-id="element-304" />

          <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold mb-6 md:mb-10" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#F5F0E8'
        }} data-id="element-305">
            La solution ?
          </h2>

          <div className="space-y-4 md:space-y-6 text-base md:text-xl leading-relaxed" style={{
          fontFamily: 'DM Sans, sans-serif',
          color: '#C8C0B0'
        }} data-id="element-306">
            <p data-id="element-307">Ce n'est pas mieux s'organiser.</p>
            <p className="text-xl md:text-3xl font-bold my-4 md:my-8" style={{
            color: '#D4A853',
            fontFamily: 'Playfair Display, serif'
          }} data-id="element-308">
              C'est EXTERNALISER.
            </p>
            <p data-id="element-309">Vider ton cerveau dans un système qui retient à ta place.</p>
            <p data-id="element-310">En 10 minutes. Chaque soir.</p>
            <p className="text-xl md:text-2xl font-bold mt-4 md:mt-8" style={{
            color: '#F5F0E8'
          }} data-id="element-311">
              C'est La Méthode OFF.
            </p>
          </div>
        </div>
      </div>
    </section>;
}